import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import tokens from '@/dashboard/tokens.json';

function DashboardErrorBoundary() {
  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      <Typography component="p" role="alert">
        {tokens['GENERAL_ERROR']}
      </Typography>
    </Box>
  );
}

export default DashboardErrorBoundary;
